import { makeStyles, withStyles } from '@mui/styles'
import Autocomplete from '@mui/material/Autocomplete'

import SearchIcon from '@assets/images/onboarding/search.png'
import ThemeInterface from '@/theme-interface'
import { isMeinBuero } from '@/utils/build-env'

const isMBO = isMeinBuero()

export const StyledAutocomplete = withStyles(theme => ({
  root: {
    width: '100%',
    '& .Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: theme.activeInputBorder,
      },
    },
    '& label.Mui-focused': {
      color: 'inherit',
    },
  },
}))(Autocomplete)

export const useNewStyles = makeStyles((theme: ThemeInterface) => ({
  wrapper: {
    '& .MuiTextField-root': {
      backgroundColor: theme.backgroundColor,
      '& legend': {
        display: 'inherit',
      },
      '& .MuiOutlinedInput-input': {
        height: 'inherit',
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(15px, 17px) scale(1)',
        paddingLeft: 45,
        '&.MuiInputLabel-shrink': {
          transform: 'translate(-19px, -4px) scale(0.75)',
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        border: theme.border,
        borderRadius: theme.borderRadius,
      },
    },
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 20,
    paddingLeft: isMBO ? 0 : 15,
    '@media (min-width: 800px)': {
      marginBottom: 'unset',
    },
  },
  input: {
    '& .MuiInputBase-root': {
      paddingLeft: 15,
      padding: 0,
      '&:before': {
        content: '""',
        display: 'block',
        background: `url(${SearchIcon}) center center no-repeat`,
        width: 30,
        height: 45,
      },
    },
  },
  label: {
    marginBottom: 10,
    color: theme.text,
    fontSize: 13,
  },
}))

export const useStyles = makeStyles((theme) => ({
  wrapper: {
    '& .MuiTextField-root': {
      '& legend': {
        display: 'inherit',
      },
      '& .MuiOutlinedInput-input': {
        height: 'inherit',
      },
      '& .MuiInputLabel-outlined': {
        transform: 'translate(15px, 20px) scale(1)',
        paddingLeft: 45,
        '&.MuiInputLabel-shrink': {
          transform: 'translate(-19px, -4px) scale(0.75)',
        },
      },
    },
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    marginBottom: 20,
    '@media (min-width: 800px)': {
      marginBottom: 'unset',
    },
  },
  input: {
    '& .MuiInputBase-root': {
      paddingLeft: 15,
      '&:before': {
        content: '""',
        display: 'block',
        background: `url(${SearchIcon}) center center no-repeat`,
        width: 30,
        height: 30,
      },
    },
  },
  label: {},
}))
